import React from 'react'
import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const Label = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.14px;
  text-align: left;
  display: flex;
  flex-wrap: nowrap;
  color: #343434;
`

function NotificationFooter({ children, style = null, size = 1 }) {
  return (
    <Label size={size} style={style}>
      {' '}
      {children}
    </Label>
  )
}

export default NotificationFooter
